/*******************************************************************************
 * @ngdoc    object
 * @module   csm.books.InitialSetup.services
 * @name     csm.books.InitialSetup.services.Data.type:SetupJournal
 * @description
 * Setup journal entry for Opening Balance amounts. `add` method takes current
 * and previous amounts to facilitate creating items for a date period.
 *
 * This is a client-side only type. It is not deserialized from the server.
 *******************************************************************************/
/* @ngInject */ export function setupJournalConfig(TypeFactoryProvider) {
  TypeFactoryProvider.addType({
    name: 'Data.SetupJournal',
    $type: 'csm.books.data.setup.SetupJournal, CSMBooks',
    prototype: function ($injector, Tools) {
      return Object.defineProperties(
        {
          date: null, // Journal Entry Date.
          memo: null,
          items: [], // List of <b>JournalItem</b> objects.

          add: $injector.invoke(add)
        },
        {
          totalCredits: {
            get: function () {
              return Tools.roundMoney(
                this.items.reduce(function (total, item) {
                  return total + item.cr;
                }, 0)
              );
            }
          },
          totalDebits: {
            get: function () {
              return Tools.roundMoney(
                this.items.reduce(function (total, item) {
                  return total + item.dr;
                }, 0)
              );
            }
          }
        }
      );
    },
    constructor: function ($injector) {
      return $injector.invoke(constructor);
    }
  });
};

/***************************************************************************
 * Constructor */
/**
 * Sets the date and memo.
 *
 * @param  {Date}   date  Journal entry date.
 * @param  {string} memo  Memo text.
 ***************************************************************************/
/* @ngInject */ function constructor() {
  return function (date, memo) {
    this.date = date;
    this.memo = memo;
    this.items = [];
  };
}

/***************************************************************************
 * add */
/**
 * Adds an account balance/current amount line item to the entry. Line item
 * amount is <b>current</b> less <b>previous</b>. Dr or Cr is determined from
 * account side. Item is not added if the amount is 0.
 *
 * @param  acct  Account Information
 * @param  prev  Previous Balance, default=0
 * @param  curr  Current Balance/Amount
 ***************************************************************************/
/* @ngInject */ function add(Data, Tools) {
  return function add(acct, prev, curr) {
    var item = new Data.SetupJournalItem(acct);
    if ((item.amount = Tools.roundMoney(curr - (prev || 0))) != 0)
      this.items.push(item);
  };
}
